import { createApp } from 'vue'
import App from './App.vue'
import router from './router' // 引入路由

// Vue.config.productionTip = false

const vue = createApp(App)
vue.use(router)
vue.mount('#app')